import { useState,} from 'react';
import { Checkbox, Col, DatePicker, Descriptions, Divider, Flex, Input, InputNumber, Radio, Row, Select, Space, Table, Tag } from 'antd';
import { BaseButton, BaseTimePicker, FillButton, OutlinedButton, DataGrid, DownloadButton, PinButton, UploadButton, RoundTag } from 'components/elements';
import { IconArrowDownCircle, IconArrowUpCircle, IconCaretDown, IconCaretUp, IconFilePdf, IconPrinter } from 'components/assets/icons';
import { BaseContainer, BaseSegmented } from 'components/containers';
import { GridSetting, DownloadExcel } from 'pages/common';
import dayjs from 'dayjs';
import { SeqItem } from 'components/biz';

const { TextArea } = Input;

function SampleTab0() {
  const [options, setOptions] = useState(['Daily', 'Weekly', 'Monthly']);
  const footer = ()=> <div className='text-red text-right'>108 권 875,000 원</div>
  
  const items1 = [
    {
      key: '1',
      label: '이름',
      children: '인천지사',
    },
    {
      key: '2',
      label: '개설희망지역',
      children: '서울시 은평구 증산로',
    },    
    {
      key: '3',
      label: '인지경로',
      children: '네이버 검색',
    },        
  ];
  const items2 = [
    {
      key: '1',
      label: '가맹 목표',
      children: '100',
    },
    {
      key: '2',
      label: '당월 계약',
      children: '100',
    },    
    {
      key: '3',
      label: '누적 계약',
      children: '100',
    },  
    {
      key: '4',
      label: '목표 성취율',
      children: '100',
    },  
    {
      key: '5',
      label: '당월 가맹상담',
      children: '100',
    },            
    {
      key: '6',
      label: '당월 해지',
      children: '100',
    }, 
    {
      key: '7',
      label: '해지율',
      children: '100',
    },       
  ];
  const methodOptions = [
    {
      label: '관리자승인',
      value: '1',
    }, {
      label: '카드결제',
      value: '2',
    }, {
      label: '적립금결제',
      value: '3',
    }, 
  ]
  const items3 = [
  {
    key: '1',
    label: '학습기간',
    span: 1,
    children: '',
  },
  {
    key: '2',
    label: '신청일',
    span: 2,
    children: '',
  },    
  {
    key: '3',
    label: '결제방식',
    span: 2,
    children: <Select
    placeholder={'관리자승인'}
    // value={''}
    style={{ width: '15rem' }}
    options={methodOptions}
    onSelect={() => {}}
    />,
  },  
  {
    key: '4',
    label: '주문상태',
    span: 2,
    children: <Select
    placeholder={'배송완료'}
    // value={''}
    style={{ width: '15rem' }}
    options={methodOptions}
    onSelect={() => {}}
    />
  },
  {
    key: '5',
    label: '기본교재',
    span: 1,
  },
  {
    key: '6',
    label: '검사지',
    span: 1,
    children: '',
  },    
  {
    key: '7',
    label: '기타/물품',
    span: 1,
    children: '0 원',
  },  
  {
    key: '8',
    label: '배송비',
    span: 1,
  },
  {
    key: '9',
    label: '사용 적립금',
    span: 1,
    children: '0 원',
  },
  {
    key: '10',
    label: '결제금액',
    span: 1,
    children: <span style={{ color: 'red' }}>0 원</span>
  },
  {
    key: '11',
    label: '환불',
    span: 1,
    children: <span style={{ color: 'red' }}>0 원</span>
  },  
];  


  return (
    <BaseContainer>
      <Row>
        <BaseSegmented options={options} />
        <BaseSegmented options={options} disabled />
      </Row>
      <Row>
        <Col span={24}>
          <Space>
            <FillButton label='수정' backgroundColor={'var(--color-blue01)'} />
            <OutlinedButton label='상세' color={'var(--color-blue01)'} />
            <OutlinedButton label='삭제' color={'var(--color-red04'} />
            <OutlinedButton label='상세보기' color={'var(--color-gray02)'} backgroundColor={'var(--color-gray01)'} />
            {/* <OutlinedButton label='해제' color={'var(--color-gray03)'} borderRadius='99px' />
            <OutlinedButton label='사회탐구' color={'var(--color-blue01)'} borderRadius='100px' /> */}
          </Space>
        </Col>
      </Row>
      <Divider className='divider' />
      <Row>
        <Col span={24}>
          <Space>
            <FillButton label='보기' backgroundColor={'var(--color-blue01)'} />
            <FillButton label='검색하기' backgroundColor={'var(--color-gray03)'} />
            <FillButton label='보내기' backgroundColor={'var(--color-gray03)'} />
            {/* <FillButton label='승인' backgroundColor={'var(--color-gray03)'} borderRadius='99px' /> */}
            <OutlinedButton label='목록' color={'var(--color-gray03)'} />
            <FillButton label='닫기' color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'} />  
            <FillButton label='이전페이지' color={'#ffffff'} backgroundColor={'var(--color-gray05)'} />  
            {/* <FillButton label='저장' color={'var(--color-gray02)'} backgroundColor={'var(--color-gray01)'} /> */}
            {/* <FillButton label='5세 과정' backgroundColor={'var(--color-blue01)'} borderRadius='100px' /> */}
          </Space>
        </Col>
      </Row>
      <Divider className='divider' />
      <Row>
        <Col span={24}>
          <Space>
            {/* <BaseButton label='수정' /> */}
            <BaseButton label='목록' />
            <BaseButton label='초기화' />
             
          </Space>
        </Col>
      </Row>
      <Divider className='divider' />    
      <Row>
        <Col span={24}>
          <Space>
            {/* <RoundSmallTag label='본사' color='blue' />   
            <RoundMediumTag label='본사' color='blue' />   
            <RoundSmallTag label='승인' color="purple" />   
            <RoundSmallTag label='반려' color="orange" /> 
            <RoundSmallTag label='제한' color="volcano" />    
            <RoundSmallTag label='정상' color="green" />        */}
            <RoundTag label='승인' color="purple" /> 
            <RoundTag label='반려' color="orange" />   
            <RoundTag label='f' color='blue' />  
            <RoundTag label='New' color='blue' />  
            <RoundTag label='?' color='var(--color-orange01)' /> 
            <RoundTag label='인천지사' color='blue' closable={true} />  
          </Space>
        </Col>
      </Row>
      <Divider className='divider' />       
      <Row>
        <Col>
          <Space>
            <UploadButton color='var(--color-gray06)' /> 
            <DownloadButton color='var(--color-gray06)' />
            <DownloadButton text='양식 다운로드' color='var(--color-gray06)' />  
            <UploadButton color='var(--color-blue01)' /> 
            <DownloadButton color='var(--color-blue01)' />     
            <UploadButton border='none' color='var(--color-blue01)' />
            <DownloadButton border='none' color='var(--color-blue01)' />
          </Space>
        </Col>
      </Row>    
      <Divider className='divider' />       
      <Row>
        <Col>
          <Space>
            <OutlinedButton label='엑셀양식 다운로드' borderRadius='100px' color={'var(--color-green01)'} />    
          </Space>
        </Col>
      </Row>         
      <Divider className='divider' />   
      <Row>
        <Col>
          <BaseButton label='파일선택' /><Input value='선택된 파일 없음' disabled style={{ width: '16rem' }} />
        </Col>
      </Row>
      <Divider className='divider' />   
      <Row>
        <Col>
          <Space>
            <IconPrinter />
            <IconFilePdf />       
            <IconCaretUp />
            <IconCaretDown />  
            <IconArrowUpCircle />
            <IconArrowDownCircle />
          </Space>
        </Col>
      </Row>    
      <Divider className='divider' />         
      <Row>
        <Col span={24}>
          <Space>
            <GridSetting data={{
                defaultCheckedList: [],
                options: []
              }} onChange={() => {}} />
            <PinButton />
            <DownloadExcel label='엑셀 다운로드(검색)' params={''} />
            <DownloadExcel label='엑셀 다운로드(체크박스)' params={''} />
            <BaseButton label={'PDF 배송용 출력'} text icon={<IconPrinter />} onClick={()=>{}} />
            <BaseButton label={'PDF 배송용 출력'} text icon={<IconFilePdf />} onClick={()=>{}} />
          </Space>
          <Space>
            <Checkbox.Group options={[
                      { label: '취소신청', value: 'cancel' },
                      { label: '메모 ○', value: 'memo' },
                      { label: '사진 삽입 ○', value: 'photo' },
                      { label: '파본체크', value: 'checkup' },
                    ]} value={['cancel', 'memo']} onChange={()=>{}} />            
          </Space>
        </Col>
      </Row>    
      <Divider className='divider' />  
      <Row>
        <Col span={24}>              
          <Checkbox.Group value={['1', '2']} onChange={()=>{}} >
            <Space direction="vertical">
              <Checkbox value="1">1.자폐적(병원 진단 시 체크)</Checkbox>
              <Checkbox value="2">2.주의산만</Checkbox>
              <Checkbox value="3">3.호기심</Checkbox>
              <Checkbox value="4">4.침착함</Checkbox>
              <Checkbox value="5">5.집중함</Checkbox>
              <Checkbox value="6">6.총명함</Checkbox>
            </Space>
          </Checkbox.Group>            
        </Col>
      </Row>      
      <Divider className='divider' />     
      <Row>
        <Col>
          <Radio.Group onChange={() => {}} value={'B'}>
            <Radio value={'A'}>전체</Radio>
            <Radio value={'B'}>지사</Radio>
          </Radio.Group>                          
        </Col>
      </Row>         
      <Row>
        <Col span={24}>
          <Space>
            <Select
              placeholder={'선택'}
              // value={''}
              style={{ width: '12rem' }}
              options={methodOptions}
              onSelect={() => {}}
            />
            <DatePicker 
              value={dayjs('2023-11-01', 'YYYY-MM-DD')}
              format={'YYYY-MM-DD'} 
              inputReadOnly
              suffixIcon={null}
              onChange={(date, dateString) => {
                // console.log('dateString', dateString);
            }}/>  
            <DatePicker picker="month" style={{ width: '8rem' }} suffixIcon={false} placeholder='2023-11' />  
            <BaseTimePicker value={dayjs('12:08', 'HH:mm')} onChange={(value) => {}}/>
            <SeqItem label={'3'} />   
          </Space>
        </Col>      
      </Row>
      <Divider className='divider' />          
      <Row>
        <Col span={24}>
          <Space>
            <Input style={{ width: '30rem' }} placeholder='입력해주세요' />   
            <InputNumber style={{ width: '10rem' }} min={1} max={10} defaultValue={3} onChange={() => {}} />
            <Input addonAfter="원" placeholder="10000" style={{ width: '12rem' }} />
          </Space>
        </Col>      
      </Row>
      <Divider className='divider' />            
      <Row>
        <Col span={24}>
          <Space>
            <TextArea rows={3} style={{ width: '60rem' }} placeholder="메모" maxLength={300} /> 
          </Space>
        </Col>      
      </Row>      
      <Divider className='divider' />              
      <Row>
        <Col span={24}>
            <Descriptions bordered column={1} 
                          labelStyle={{ width: '16rem' }} 
                          contentStyle={{ textAlign: 'left' }}
                          items={items1} />         
          <Divider className='divider'/>
            <Descriptions bordered layout="vertical" column={7} 
                          labelStyle={{ textAlign: 'center' }} 
                          contentStyle={{ textAlign: 'center' }}
                          items={items2}
            />
        </Col>
      </Row>
      <Divider className='divider' />
      <Row>
        <Col span={24}>
          <Flex justify='space-between' gap='small'>
            <Space>
              <OutlinedButton label='삭제' color={'var(--color-red04'} />
              <DownloadButton text='다운로드' color='var(--color-gray06)' />  
              <OutlinedButton label='엑셀양식 다운로드' borderRadius='100px' color={'var(--color-green01)'} />    
            </Space>
            <Space>
              <FillButton label='글쓰기' backgroundColor={'var(--color-gray03)'} />
              <FillButton label='등록' backgroundColor={'var(--color-gray03)'} />
            </Space>
          </Flex>
        <Divider className='divider-small' />
          <DataGrid
              bordered={true}
              rowKey={'key'}
              columns={[
                {
                  title: '학습기간',
                  align: 'center',
                  dataIndex: 'col1',
                  width:'170px'
                },
                {
                  title: '신청일',
                  align: 'center',
                  dataIndex: 'col2',
                  width:'30rem'
                },
                {
                  title: '결제방식',
                  align: 'center',
                  dataIndex: 'col3',
                  width:'26rem',
                  render: (value, record, idx) => {
                    return idx===0 && <>
                    <Select
                    placeholder={'관리자승인'}
                    // value={''}
                    options={methodOptions}
                    style={{ width: '15rem' }}
                    onSelect={() => {}}
                    /> <FillButton label='적용' backgroundColor={'var(--color-blue01)'} />
                    </> ||  value
                  }
                },
                {
                  title: '주문상태',
                  align: 'center',
                  dataIndex: 'col4',
                  width:'26rem',
                  render: (value, record, idx) => {
                    return idx===0 && <Select
                    placeholder={'배송완료'}
                    // value={''}
                    options={methodOptions}
                    style={{ width: '15rem' }}
                    onSelect={() => {}}
                    /> || value
                  }
                    
                }
              ]}
              data={[
                { col1: '2024-01' ,
                  col2: '2023-12-18 03:55:35',
                  col3: '서울 은평구 증산로 337',
                  col4: '02-1688-1993 / 010-0000-0000',
                },
                { col1: <BaseButton label='초기화' />,
                  col2: <OutlinedButton label='상세' color={'var(--color-blue01)'} />,
                  col3: <FillButton label='보기' backgroundColor={'var(--color-blue01)'} />,
                  col4: <Space>
                    <FillButton label='수정' backgroundColor={'var(--color-blue01)'} />
                    <OutlinedButton label='삭제' color={'var(--color-red04'} />
                  </Space>
                },
                { col1: <UploadButton border='none' color='var(--color-blue01)' />, 
                  col2: <DownloadButton border='none' color='var(--color-blue01)' />,     
                  col3: <FillButton label='파일' backgroundColor={'var(--color-blue01)'} />,
                  col4: <Space>
                    <FillButton label='신청' color={'var(--color-blue01)'} backgroundColor={'var(--color-blue03)'} />
                    <FillButton label='승인' color={'var(--color-violet02)'} backgroundColor={'var(--color-violet01)'} />
                    <FillButton label='반려' color={'var(--color-orange04)'} backgroundColor={'var(--color-orange03)'} />
                    <FillButton label='정상' color={'var(--color-green05)'} backgroundColor={'var(--color-green04)'} />
                    <FillButton label='제한' color={'var(--color-red07)'} backgroundColor={'var(--color-red06)'} />
                  </Space> 
                },
                { col1: <FillButton label='등록' backgroundColor={'var(--color-blue01)'} /> ,
                  col2: <Space>
                          <FillButton label='결제하기' backgroundColor={'var(--color-blue01)'} />
                          <OutlinedButton label='주문수정' color={'var(--color-gray03)'}  />
                          <OutlinedButton label='주문취소' color={'var(--color-red04'} />
                        </Space>,
                  col3: <Flex vertical align='center' gap='small'>
                          <RoundTag label='휴회신청중'  color='var(--color-gray01)' style={{color:'var(--color-gray09)'}}  /> 
                          <RoundTag label='이동신청중'  color='var(--color-gray01)' style={{color:'var(--color-gray09)'}}  /> 
                          <FillButton label='휴회신청' backgroundColor={'var(--color-blue01)'} />
                          <OutlinedButton label='휴회신청취소' color={'var(--color-blue01)'} />
                        </Flex>,
                  col4: <Flex vertical align='center' gap='small'>
                          <RoundTag label='신청' color='blue' />
                          <RoundTag label='교환' color='blue' />
                          <RoundTag label='환불' color='green' />
                          <RoundTag label='승인' color='purple' />
                          <RoundTag label='반려' color='orange' />
                          <RoundTag label='SMS발송' color='blue' />
                          <RoundTag label='관리자 승인 완료' color="processing" />
                        </Flex>
                },
                { col1: <FillButton label='추가' backgroundColor={'var(--color-blue01)'} /> ,
                  col2: <Space>
                          <FillButton label='반품' color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'}/>  
                          <FillButton label='반품취소' color={'#fff'} backgroundColor={'var(--color-red04)'} />
                        </Space>,
                  col3: <Space>
                          <Flex justify='center' gap='small'>
                                  <RoundTag label='본사' color={'#7FB5F1'} style={{color:'#0257B5'}} /> 
                                  <RoundTag label='지사' color={'#81DE84'}  style={{color:'#008D05'}} /> 
                                  <RoundTag label='교육원' color={'#FFDE88'}  style={{color:'#CE6F00'}} /> 
                          </Flex>
                          <TextArea rows={3} style={{ width: '20rem' }} placeholder="메모" maxLength={100} disabled/> 
                        </Space>,
                  col4: <Flex vertical align='center' gap='small'>
                          <RoundTag label='환불 신청중' color='blue' />
                          <RoundTag label='환불 취소' color='red' />
                          <RoundTag label='환불 완료' color='green' />
                        </Flex>
                },
              ]}
            />  
          <Divider className='divider' />
        </Col>
      </Row>
      <Flex justify='center' gap='small'>
          <OutlinedButton label='삭제' color={'var(--color-red04'} />
          <FillButton label='수정하기' backgroundColor={'var(--color-blue01)'} />
          <FillButton label='추가' backgroundColor={'var(--color-blue01)'} />
          <OutlinedButton label='목록' color={'var(--color-gray03)'} />
          <OutlinedButton label='취소하기' color={'var(--color-gray03)'} />
          <FillButton label='작성완료' backgroundColor={'var(--color-gray03)'} />
          <FillButton label='주문하기' backgroundColor={'var(--color-gray03)'} />
          <FillButton label='제출하기' backgroundColor={'var(--color-gray03)'} />
          <FillButton label='닫기' color={'var(--color-gray03)'} backgroundColor={'var(--color-gray04)'}/>  
          <FillButton label='이전페이지' color={'#ffffff'} backgroundColor={'var(--color-gray05)'}/>  
      </Flex>
      <Divider className='divider' />
      <Row>
        <Col span={24}>
          <Descriptions bordered layout="vertical" column={7} 
                        labelStyle={{ textAlign: 'center' }} 
                        contentStyle={{ textAlign: 'center' }}
                        items={items3} />   
        </Col>
      </Row>
      <Divider className='divider' />
      <Row>
        <Col span={24}>
          <DataGrid
              bordered={true}
              rowKey={'key'}
              columns={[
                {
                  title: '학습기간',
                  align: 'center',
                  dataIndex: 'col1',
                  colSpan:2,
                  width:'170px'
                },
                {
                  title: '신청일',
                  align: 'center',
                  dataIndex: 'col2',
                  colSpan:0,
                  width:'30rem'
                },
                {
                  title: '결제방식',
                  align: 'center',
                  dataIndex: 'col3',
                  width:'26rem',
                  render: (value, record, idx) => {
                    return <Select
                    placeholder={'관리자승인'}
                    // value={''}
                    options={methodOptions}
                    style={{ width: '15rem' }}
                    onSelect={() => {}}
                    />
                  }
                },
                {
                  title: '금액',
                  align: 'center',
                  dataIndex: 'col4',
                }
              ]}
              data={[
                { col1: '2024-01' ,
                  col2: '2023-12-18 03:55:35',
                  col3: '서울 은평구 증산로 337',
                  col4: 100,
                },
              ]}
              summary={(pageData) => {
                let totalcol4 = 0;
                pageData.forEach(({ col4 }) => {
                  totalcol4 += col4;
                });
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0} colSpan={5}>
                        <Flex justify='flex-end' gap={'small'} className='text-red'>
                          <p>{totalcol4} 건</p>
                          <p>{totalcol4} 건</p>
                        </Flex>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>

                  </>
                );
              }}
            />  
        </Col>


      </Row>

    </BaseContainer>
  );
}
export default SampleTab0;
